export const GeneralPasswordMaxLength = 100;
export const SnaPasswordMinLength = 8;
export const SnaPasswordMaxLength = 16;
